var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { lighten, TableFooter } from "@mui/material";
import { TableRow } from "../../Molecules";
import { COLORS } from "../../../../../constants";
import { Select } from "../../../../Atoms";
import { MemoTableCell } from "../../Molecules";
var defaultCellData = {
    style: "text",
    tdBodyProps: {
        textProps: {
            emphasis: "medium",
            variant: "subtitle3",
        },
    },
};
var TableCalculations = function (_a) {
    var select = _a.select, values = _a.values;
    return (_jsx(TableFooter, __assign({ sx: {
            background: lighten(COLORS.LIGHT_GREY, 0.5),
            height: 32,
        } }, { children: _jsxs(TableRow, { children: [select && (_jsx(MemoTableCell, __assign({ footer: true, columnName: "tableFooterCalcs", memoComparitor: select.selectProps.value, cellId: "tableFooterCalcs" }, select.cellProps, { children: _jsx(Select, __assign({ "data-testid": "table-footer-select", variant: "standard", formControlSx: {
                            width: "auto",
                        }, sx: {
                            mr: 3,
                            borderBottom: "none",
                        } }, select.selectProps)) }))), values.map(function (_a) {
                    var value = _a.value, name = _a.name, cellData = _a.cellData, rest = __rest(_a, ["value", "name", "cellData"]);
                    return (_jsx(MemoTableCell, __assign({ footer: true, content: value, memoComparitor: value, columnName: name, cellData: __assign(__assign({}, defaultCellData), cellData), cellId: "footer-".concat(name) }, rest), name));
                })] }) })));
};
export default React.memo(TableCalculations);
